import CustomButton from "./CustomButton";
import CustomLoader from "./CustomLoader";
import CustomHeader from "./Header";
import OTPTextInput from "./OTPTextInput";
import CustomModal from "./CustomModal";
import CacheImage from "./CacheImage";

import { scale, verticalScale, moderateScale } from "./Scale";
import { showSimpleAlert, isValidEmail, isValidPassword, getFileExtension, multiply, add, } from "./HelperFunction";
import { isIphoneX, ifIphoneX, getStatusBarHeight, getBottomSpace, getBottomMoreSpace } from "./iPhoneHelp";

import * as iPhoneHelp from "./iPhoneHelp";
import * as HelperFunction from "./HelperFunction";
/**
 * Exporting Components and methods
 */
export {
  CustomLoader,
  CustomButton,
  CustomHeader,
  OTPTextInput,
  scale,
  verticalScale,
  moderateScale,
  multiply,
  add,
  showSimpleAlert,
  isValidEmail,
  isValidPassword,
  getFileExtension,
  isIphoneX,
  ifIphoneX,
  getStatusBarHeight,
  getBottomSpace,
  getBottomMoreSpace,
  iPhoneHelp,
  HelperFunction,
  CustomModal,
  CacheImage
}
